module.exports = __webpack_public_path__ + "img/lg_ring_r_c_0_null@3x.be5792f1.png";